export const projectStatus = {
  altText: 'Statusanzeige des Projektes',
}
